// Textos do cardápio em português: são os textos de sempre, copiados das telas. Mudar um texto aqui muda
// o que a loja brasileira vê.

export default {
    geral: {
        continuar: 'Continuar',
        concluir: 'Concluir',
        cancelar: 'Cancelar',
        ok: 'Ok',
        todas: 'Todas',
        pesquisar: 'Digite para pesquisar...',
        quantidade: 'Quantidade',
        idioma: 'Idioma',
        observacao: 'Observação',
    },

    // Nomes gravados pelo sistema; em português a tela mostra o que está no banco (tSistema).
    sistema: {
        formaEntrega: {
            1: 'Retirar no Balcão',
            2: 'Delivery',
            3: 'Mesa',
        },
        formaPagamento: {
            1: 'Dinheiro',
            2: 'Cartão de Credito',
            3: 'Pix',
            4: 'Cartão de Debito',
        },
    },

    horario: {
        fechado: 'FECHADO',
        fechadoHoje: 'FECHADO HOJE',
        abertoAte: 'ABERTO ATÉ ÀS {hora}',
        fechadoAbre: 'FECHADO, ABRE ÀS {hora}',
        titulo: 'Horários de funcionamento',
        dias: {
            1: 'Segunda-feira',
            2: 'Terça-feira',
            3: 'Quarta-feira',
            4: 'Quinta-feira',
            5: 'Sexta-feira',
            6: 'Sábado',
            7: 'Domingo',
        },
    },

    produto: {
        aPartirDe: 'A partir de {valor}',
        esgotadoCaixaAlta: 'PRODUTO ESGOTADO',
        esgotado: 'Esgotado',
        avisoEsgotado: 'Produto esgotado',
        indisponivel: 'Indisponível',
        restamUnidades: 'Restam {n} unidades',
        restaUma: 'Resta apenas 1 unidade',
        restamEmEstoque: 'Restam apenas {n} em estoque',
        resgatePor: 'Resgate por {n} pontos',
    },

    cardapio: {
        agendeSeuPedido: 'Agende seu pedido!',
        entrega: 'Entrega',
        retirada: 'Retirada',
        horarios: 'Horários',
        localizacao: 'Localização',
        fidelidadeTitulo: 'Programa de fidelidade',
        fidelidadeTexto: 'A cada {valor} em compras você ganha {ponto} que pode ser trocado por prêmios.',
        umPonto: '1 ponto',
        semProdutos: 'Opa! O cadastro de produtos está em andamento. Volte mais tarde para conferir nossas novidades!',
        estamosFechados: 'Estamos fechados agora, consulte nossos horários de atendimento',
        prazo: '{inicio} à {fim}',
        inicio: 'Início',
        pesquisarProduto: 'Pesquise por um produto',
    },

    etapa: {
        valorAdicional: 'Valor adicional: {valor}',
        nenhumaOpcao: 'Nenhuma opção encontrada.',
        irPara: 'Ir para {produto}',
        estoqueDisponivel: 'Estoque disponível: {n}',
        quantidadeMaxima: 'Quantidade máxima permitida: {n}',
        escolhaUma: 'Escolha uma opção',
        escolhaAoMenos: 'Escolha ao menos {n}',
        minimoDe: 'Mínimo {n} de {item}',
        escolhidoUm: ' · {n} escolhido',
        escolhidos: ' · {n} escolhidos',
        escolha1Opcao: 'Escolha 1 opção',
        escolha1SeQuiser: 'Escolha 1, se quiser',
        escolhaN: 'Escolha {n}{escolhidos}',
        escolhaDeAte: 'Escolha de {min} a {max}{escolhidos}',
        ateOpcoes: 'Até {max} opções{escolhidos}',
        opcional: 'Opcional',
        obrigatorio: 'Obrigatório',
        pronto: 'Pronto',
        progresso: 'Etapa {atual} de {total}',
        digitarQuantidadeDe: 'Toque para digitar a quantidade de {item}',
        quantidadeDe: 'Quantidade de {item}',
        digitarQuantidade: 'Toque para digitar a quantidade',
    },

    resumo: {
        titulo: 'Confira seu pedido!',
        entregaGratisAPartir: 'Entrega Grátis à partir de {valor}',
        entregaGratis: 'Entrega Grátis',
        premios: 'Há {n} {produtos} no seu carrinho que podem ser resgatados por pontos',
        produto: 'produto',
        produtos: 'produtos',
        pontosDisponiveis: '{n} pontos disponíveis',
        entreParaAcumular: 'Entre ou cadastre-se para acumular pontos!',
        subtotal: 'Subtotal: {valor}',
        semPontos: 'Sem pontos suficientes',
        resgatar: 'Resgatar',
        resgatou: 'Resgatou por {n} pontos',
        desfazer: 'Desfazer',
        total: 'TOTAL {valor}',
        continuarComprando1: 'Continuar',
        continuarComprando2: 'Comprando',
        finalizarPedido1: 'Finalizar',
        finalizarPedido2: 'Pedido',
        digiteObservacao: 'Digite a observação...',
        adicional: '(Adicional {valor})',
    },

    orderBump: {
        minimo: 'Minimo: {n}',
        maximo: 'Máximo: {n}',
        valorAdicional: 'Valor Adicional: {valor}',
        escolhaNoMinimo: 'Escolha no mínimo {n}',
    },

    // Endereço do cliente: rótulos que dependem do país da loja (CEP × ZIP) ficam por país.
    endereco: {
        codigoPostal: { BR: 'CEP', US: 'ZIP code' },
        estado: { BR: 'UF', US: 'Estado' },
        bairro: 'Bairro',
        bairroOpcional: 'Bairro (opcional)',
        rua: 'Rua / Logradouro / Avenida',
        numero: 'Número',
        pontoReferencia: 'Ponto de referência',
        nomePredio: 'Nome do prédio',
        numeroApartamento: 'Nº do apartamento',
        selecioneMunicipio: 'Selecione o seu Município',
        selecioneBairro: 'Selecione o seu Bairro',
        padrao: 'padrão',
        tipo: {
            casa: 'Casa',
            apartamento: 'Apartamento',
            trabalho: 'Trabalho',
            condominio: 'Condomínio',
            endereco: 'Endereço',
        },
    },

    envio: {
        titulo: 'Preencha os campos',
        nomeCompleto: 'Nome completo',
        whatsapp: 'WhatsApp',
        emailOpcional: 'E-mail (opcional)',
        emailDica: 'Enviaremos um e-mail quando seu pedido estiver pronto.',
        aniversario: 'Aniversário',
        formatoAniversario: 'DD/MM',
        entregar: 'Entregar',
        vouRetirar: 'Vou retirar',
        consumirNoLocal1: 'Consumir',
        consumirNoLocal2: 'no local',
        quandoSera: 'Quando será a entrega / retirada?',
        hoje: 'Hoje',
        agendar: 'Agendar',
        dataAgendamento: 'Data do agendamento',
        horario: 'Horário',
        formatoData: 'DD/MM/YYYY',
        enderecoEntrega: 'Endereço de entrega',
        informeEnderecoEntrega: 'Informe o endereço de entrega',
        alterar: 'Alterar',
        informar: 'Informar',
        seusEnderecos: 'Seus endereços',
        definirPadrao: 'Definir como padrão',
        excluir: 'Excluir',
        cadastrarOutro: 'Cadastrar outro endereço',
        gerenciarEnderecos: 'Gerenciar endereços',
        editarEndereco: 'Editar endereço',
        confirmar: 'Confirmar',
        temCupom: 'Você tem um cupom?',
        informeCupom: 'Informe seu cupom',
        aplicar: 'Aplicar',
        cupomPrimeiroPedido: 'Este cupom vale para o primeiro pedido.',
        cupomExclusivo: 'Este cupom é exclusivo para clientes cadastrados.',
        entrarOuCriarConta: 'Entrar ou criar conta',
        entrar: 'Entrar',
        restaUmUso: 'resta 1 uso',
        restamUsos: 'restam {n} usos',
        regras: 'Regras:',
        regraPrimeiroPedido: 'Válido somente para o {destaque}',
        primeiroPedido: 'primeiro pedido',
        regraGrupos: 'Válido somente para os grupos de produtos: {lista}',
        regraEntrega: 'Válido somente para: {lista}',
        regraPagamento: 'Válido somente para pagamento em: {lista}',
        regraValorMinimo: 'Válido para pedidos a partir de {valor}',
        faltam: '(faltam {valor})',
        separadorOu: ' ou ',
        trocoParaQuanto: 'Troco para quanto?',
        naoPrecisoTroco: 'Não preciso de troco',
        copiarPix: 'Copiar Chave Pix',
        subtotal: 'Subtotal',
        acrescimo: 'Acréscimo',
        desconto: 'Desconto',
        premio: 'Prêmio',
        taxaEntrega: 'Taxa de Entrega',
        total: 'Total',
        pagar: 'Pagar',
        enviar: 'Enviar',
        pedidoConfirmado: 'Pedido Confirmado!',
        filaPreparo1: 'Seu pedido já está na',
        filaPreparo2: 'fila de preparo.',
        envieNoWhatsapp: 'Envie o pedido no WhatsApp e acompanhe o andamento!',
        enviarNoWhatsapp: 'Enviar no WhatsApp',
        acompanharPedido: 'Acompanhar Pedido',
        confirmacao: 'Confirmação',
        confirmaEndereco: 'Confirma que seu endereço é:',
        excluirEnderecoTitulo: 'Excluir endereço',
        excluirEnderecoTexto: 'Deseja excluir este endereço da sua conta?',
        enderecoAlteradoTitulo: 'Endereço alterado',
        enderecoAlteradoTexto: 'Você alterou o endereço selecionado.<br><br>Toque em <b>Confirmar</b> para <b>atualizá-lo</b>, ou em <b>Salvar como novo</b> para manter o anterior e criar um novo.',
        salvarComoNovo: 'Salvar como novo',
        avisos: {
            cupomExclusivoRemovido: 'O cupom exclusivo foi removido porque você saiu da conta',
            informeRuaNumero: 'Informe ao menos a rua e o número',
            selecioneTipoEndereco: 'Selecione o tipo do endereço (casa, apartamento ou trabalho)',
            codigoPostalValido: 'Informe um {rotulo} válido',
            naoSalvouEndereco: 'Não foi possível salvar o endereço',
            naoDefiniuPadrao: 'Não foi possível definir o padrão',
            naoExcluiuEndereco: 'Não foi possível excluir o endereço',
            encerramosAgende: 'Desculpe! Ja encerramos o atendimento, você pode agendar seu pedido',
            encerramos: 'Desculpe! Ja encerramos o atendimento',
            foraDoRaio: 'Desculpe! Fora do raio de entrega',
            valorMinimo: 'Valor minimo do pedido é de {valor}',
            aniversarioInvalido: 'Informe um dia e mês válidos para seu aniversário',
            nomeSobrenome: 'Informe nome e sobrenome',
            informeNome: 'Informe nome',
            informeWhatsapp: 'Informe o Whatsapp com DDD',
            selecioneFormaEntrega: 'Selecione a forma de entrega',
            informeDataAgendamento: 'Informe a data do agendamento',
            informeHoraAgendamento: 'Informe a hora do agendamento',
            informeFormaPagamento: 'Informe a forma de pagamento',
            informeTroco: 'Informe o troco',
            trocoMaiorQueTotal: 'O troco deve ser maior que o total do pedido',
            selecioneNoMapa: 'Selecione o endereço no mapa',
            informeMunicipio: 'Informe o município',
            informeBairro: 'Informe o bairro',
            selecioneMunicipioLista: 'Selecione o município na lista para calcular a entrega',
            selecioneBairroLista: 'Selecione o bairro na lista para calcular a entrega',
            informeRua: 'Informe a rua',
            informeNumero: 'Informe o número residencial',
            informeTipoLocal: 'Informe o tipo da localidade',
            informeEdificio: 'Informe o nome do edificio',
            informeApartamento: 'Informe o número do apartamento',
            informeCodigoPostalEntrega: 'Informe o {rotulo} para a entrega',
            muitasTentativasCupom: 'Muitas tentativas de cupom. Aguarde 1 minuto e tente de novo.',
            verifiqueConexao: 'Verifique sua conexão com a internet',
            cupomInvalido: 'Cupom inválido ou expirado',
            cupomParabens: 'Parabéns, cupom aplicado',
            loginSucesso: 'Login efetuado com sucesso',
            cupomAplicado: 'Cupom aplicado',
            faltamParaCupom: 'Faltam {valor} para este cupom valer',
            taxaEntrega: 'Taxa de entrega {valor}',
            pixCopiada: 'Chave pix copiada!',
            naoCopiou: 'Não foi possivel copiar!',
            envieAntesDeSair: 'Atenção: Envie o pedido antes de sair desta página. Toque no botão verde "Enviar"',
            localizacaoConfirmada: 'Localização confirmada!',
            enderecoNaoEncontrado: 'Endereço não encontrado',
            semRotas: 'Não há rotas disponíveis para esse endereço',
            falhaDistancia: 'Falha ao calcular a distância',
            falhaGeocodificacao: 'Falha na geocodificação',
            cupomRemovido: 'Cupom removido',
        },
        // Mensagem do pedido que o cliente manda para a loja pelo WhatsApp.
        mensagem: {
            pedido: '*PEDIDO #{id}*',
            agendadoPara: '*AGENDADO PARA*: {data} {hora}',
            nome: '*Nome*: {valor}',
            whatsapp: '*WhatsApp*: {valor}',
            formaEntrega: '*Forma Entrega*: {valor}',
            prazo: '*Prazo Estimado*: {valor}',
            pagamento: '*Pagamento*: {valor}',
            endereco: '*Endereço*: {valor}',
            obs: '*Obs*: {valor}',
            cupom: '*Cupom*: {valor}',
            premioItem: '(PRÊMIO)',
            obsItem: '_Obs: ({valor})_',
            adicional: '(Adicional {valor})',
            totalProdutos: '*TOTAL PRODUTOS*: {valor}',
            premio: '*PRÊMIO*: - {valor}',
            taxaEntrega: '*TAXA DE ENTREGA*: {valor}',
            aCombinar: 'A Combinar',
            totalFinal: '*TOTAL FINAL*: {valor}',
            trocoPara: '*Troco para*: {valor}',
            total: '*TOTAL*: {valor}',
            obrigado: 'Muito obrigado pela preferência!',
            envieLocalizacao: '_Para facilitar a entrega envie-nos a Localização Fixa do Whatsapp_',
            acompanhe: '*👉Acompanhe o andamento do pedido:* {link}',
            formatoDataHora: 'DD/MM/YYYY HH:mm',
        },
    },

    pagamentoForma: {
        rotulo: 'Forma de pagamento',
    },

    status: {
        carregando: 'Atualizando informações do seu pedido...',
        verifiqueLink: 'Verifique se o link está correto ou entre em contato com o estabelecimento.',
        voltarInicio: 'Voltar ao início',
        pedido: 'Pedido',
        realizadoEm: 'Realizado em {data}',
        cancelado: 'Este pedido foi cancelado',
        finalizado: 'Pedido finalizado',
        previsao: 'Previsão para ficar pronto',
        pronto: 'Pronto',
        aguardandoTempo: 'Aguardando definição do tempo de preparo.',
        acompanheAbaixo: 'Acompanhe abaixo o andamento do seu pedido.',
        toqueAtualizar: 'Toque em {botao} para ver as últimas informações.',
        atualizarStatus: 'Atualizar status',
        passoRealizado: 'Pedido realizado',
        passoPreparacao: 'Em preparação',
        entrouNaFila: 'Entrou na fila às {hora}',
        passoSaiu: 'Saiu para entrega',
        aCaminho: 'Seu pedido já está a caminho',
        passoAguardandoRetirada: 'Aguardando retirada',
        retirarNoBalcao: 'Assim que estiver pronto você poderá retirar no balcão',
        passoConcluido: 'Concluído',
        foiConcluido: 'Seu pedido foi concluído',
        ultimaAtualizacao: 'Última atualização: {hora}',
        cliente: 'Cliente',
        formaEntrega: 'Forma de entrega',
        formaPagamento: 'Forma de pagamento',
        total: 'Total',
        entrega: {
            1: 'Retirada no balcão',
            2: 'Delivery',
            3: 'Consumo no local',
        },
        rotulos: {
            cancelado: 'Cancelado',
            confirmado: 'Confirmado',
            em_preparacao: 'Em preparação',
            aguardando_retirada: 'Aguardando retirada',
            saiu_para_entrega: 'Saiu para entrega',
            concluido: 'Concluído',
        },
        naoEncontrado: 'Pedido não encontrado 😕',
        naoConcluiu: 'Não foi possível concluir a operação 😕',
        naoConcluiuAviso: 'Não foi possivel concluir a operação',
        formatoCriadoEm: 'DD [de] MMMM HH:mm',
        formatoHora: 'HH:mm',
        formatoHoraSegundos: 'HH:mm:ss',
    },

    conta: {
        senhaRegra: 'A senha deve ter no mínimo 8 caracteres, com pelo menos 1 letra e 1 número',
        obrigatorio: 'Preenchimento obrigatório',
        digiteCodigoWhatsapp: 'Digite o código que você recebeu no WhatsApp',
        reenviarCodigo: 'Reenviar código',
        crieSenha: 'Crie sua senha',
        confirmeSenha: 'Confirme sua senha',
        digiteCodigo: 'Digite o código',
        whatsappInvalido: 'Whatsapp inválido',
        naoEnviouCodigo: 'Não foi possível enviar o código. Tente novamente em instantes.',
        senhaNaoConfere: 'A senha não confere',
        preenchaTodos: 'Preencha todos os campos',
        novaSenha: 'Nova senha',
        redefinir: 'Redefinir',
        digiteNovaSenha: 'Digite a nova senha',
        digiteSenha: 'Digite sua senha',
        digiteWhatsapp: 'Digite seu Whatsapp',
        whatsapp: 'Whatsapp',
        senha: 'Senha',
        esqueciSenha: 'Esqueci minha senha',
        digiteASenha: 'Digite a senha',
        oi: 'Oi, {nome}',
        minhaConta: 'Minha Conta',
        sair: 'Sair',
        desejaSair: 'Deseja realmente sair?',
        usuario: 'Usuário',
        pontosFidelidadeN: '{n} pontos de fidelidade',
        meusDados: 'Meus dados',
        enderecos: 'Endereços',
        pedidos: 'Pedidos',
        nome: 'Nome',
        whatsappRotulo: 'WhatsApp',
        pontosFidelidade: 'Pontos de fidelidade',
        nPontos: '{n} pontos',
        carregandoPedidos: 'Carregando seus pedidos...',
        nenhumPedido: 'Nenhum pedido por aqui',
        pedidosUltimos6Meses: 'Seus pedidos dos últimos 6 meses aparecem aqui.',
        contagemPedido: '{n} pedido · últimos 6 meses',
        contagemPedidos: '{n} pedidos · últimos 6 meses',
        pedidoN: 'Pedido #{id}',
        formatoDataHora: 'DD/MM/YYYY HH:mm',
        statusPedido: {
            aguardando_pagamento: 'Aguardando pagamento',
            pago: 'Pago',
            recebido: 'Recebido',
            cancelado: 'Cancelado',
            confirmado: 'Confirmado',
            em_preparacao: 'Em preparação',
            saiu_para_entrega: 'Saiu para entrega',
            aguardando_retirada: 'Aguardando retirada',
            concluido: 'Concluído',
        },
    },

    meusEnderecos: {
        nenhum: 'Nenhum endereço cadastrado',
        padrao: 'Padrão',
        editar: 'Editar',
        remover: 'Remover',
        adicionar: 'Adicionar endereço',
        maximo: '(máx. {n})',
        novo: 'Novo endereço',
        apelido: 'Apelido (opcional)',
        apelidoExemplo: 'Ex.: Casa, Trabalho, Casa da mãe',
        municipio: 'Município',
        rua: 'Rua / Logradouro',
        referencia: 'Ponto de referência / complemento',
        numeroApto: 'Nº do apto',
        usarComoPadrao: 'Usar como endereço padrão',
        salvar: 'Salvar endereço',
        erroCarregar: 'Erro ao carregar endereços',
        informeRuaNumero: 'Informe ao menos rua e número',
        selecioneTipo: 'Selecione o tipo (Casa, Apartamento ou Trabalho)',
        salvo: 'Endereço salvo',
        erroSalvar: 'Erro ao salvar endereço',
        erroPadrao: 'Erro ao definir padrão',
        removerTitulo: 'Remover endereço',
        removerTexto: 'Deseja remover este endereço?',
        removido: 'Endereço removido',
        erroRemover: 'Erro ao remover endereço',
    },

    tablet: {
        semConexao: 'Sem conexão com o servidor',
        mesaSemCardapio: 'A mesa está cadastrada, mas o cardápio não conseguiu ser carregado. Verifique a rede do restaurante.',
        tentarDeNovo: 'Tentar de novo',
        mesaNaoConfigurada: 'Mesa não configurada',
        naoAssociado: 'Este tablet ainda não está associado a uma mesa.',
        configurePainel: 'Configure pelo painel do tablet: toque 5 vezes no canto superior esquerdo da tela e informe o PIN.',
        nenhumProduto: 'Nenhum produto encontrado para “{busca}”.',
        tenteOutra: 'Tente outra palavra ou escolha uma categoria no menu ao lado.',
        limparBusca: 'Limpar busca',
        colunas: {
            hora: 'Hora',
            qtd: 'Qtd',
            item: 'Item',
            unitario: 'Unitário',
            valor: 'Valor',
        },
        filaPreparo: 'Seu pedido já está na fila de preparo.',
        okObrigado: 'Ok, obrigado',
        carrinhoCompras: 'Carrinho de Compras',
        carrinhoVazio: 'Seu carrinho está vazio',
        carrinhoVazioTexto: 'Escolha um produto no cardápio e ele aparece aqui para você conferir antes de enviar à cozinha.',
        verCardapio: 'Ver cardápio',
        itensEnviados: 'Você já tem itens enviados nesta mesa — veja em {conta}.',
        adicionarAoPedido: 'Adicionar ao Pedido',
        reservado: 'RESERVADO',
        reservadoPara: 'para {nome}',
        toqueParaFechar: 'Toque para fechar',
        mesa: 'MESA {n}',
        mesaN: 'Mesa {n}',
        minhaConta1: 'Minha',
        minhaConta2: 'Conta',
        carrinho: 'Carrinho',
        observacoes: 'Observações',
        observacoesExemplo: 'Ex.: sem cebola, ponto da carne...',
        confiraPedido: 'Confira seu pedido',
        semPersonalizacao: 'Você não adicionou nenhuma personalização.',
        voltar: 'Voltar',
        confiraProduto: 'Confira o produto',
        adicioneAoCarrinho: 'Adicione ao carrinho',
        revisaoPedido: 'Revisão do pedido',
        adicionar: 'Adicionar',
        personalizar: 'Personalizar',
        falta: 'Falta: {etapa}',
        horariosFuncionamento: 'Horários de Funcionamento',
        fechado: 'Fechado',
        anuncioZaper: 'Cardápio digital inteligente para o seu restaurante',
        configuracaoMesa: 'Configuração da Mesa',
        trocarMesa: 'Para trocar a mesa, use o painel do tablet: toque 5 vezes no canto superior esquerdo da tela e informe o PIN.',
        reservarMesa: 'Reservar Mesa',
        fechar: 'Fechar',
        nomeClienteOpcional: 'Nome do cliente (opcional)',
    },

    mapa: {
        trocarEndereco: 'Trocar endereço',
        selecionarNoMapa: 'Selecionar endereço no mapa',
        selecioneLocalizacao: 'Selecione sua localização',
        instrucao: 'Selecione o seu local no mapa ou utilize o botão "Meu local".',
        meuLocal: 'Meu local',
        salvar: 'Salvar',
    },

    rodape: {
        sigaRedes: 'Siga nossas redes sociais!',
        desenvolvidoPor: 'Desenvolvido por {empresa} com ☕ & ❤️',
        queroCriar: 'Quero criar meu Cardápio Digital',
        aguardeCarregando: 'Aguarde, carregando...',
        imprimir: 'Imprimir',
    },

    estoque: {
        semEstoqueTitulo: 'Produto sem estoque!',
        semEstoqueVazio: 'Lamentamos, mas este produto não possui mais estoque suficiente, volte ao cardápio para continuar seu pedido.',
        disponivel: ' | Disponível: {n}',
        semEstoqueTexto: 'Lamentamos, os produtos acima não possuem mais estoque suficiente no momento.',
        semEstoqueVoltar: 'Você pode {destaque} e adicionar outros produtos ao seu pedido antes de finalizá-lo.',
        voltarAoCardapioMinusculo: 'voltar ao cardápio',
        voltarAoCardapio: 'Voltar ao cardápio',
        indisponivelTitulo: 'Item indisponível!',
        indisponivelTexto: 'Lamentamos, mas os itens acima não estão mais disponíveis no momento.',
        indisponivelRemovidos: 'Eles serão removidos do seu carrinho para que você possa continuar.',
    },
};
